// extracted by mini-css-extract-plugin
export var dropdownIcon = "_m2-6";
export var imgContainer = "_m2-3";
export var menuIcon = "_m2-5";
export var pillWrapper = "_m2-2";
export var pillsContainer = "_m2-1";
export var subscriptionCard = "_m2-0";
export var subscriptionLogo = "_m2-4";